import styled, { css, keyframes } from 'styled-components';

/* Soft enter — avoid opacity:0 (reads as a white flash on navigate). */
const riseIn = keyframes`
  from {
    opacity: 0.92;
    transform: translateY(8px) scale(0.995);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const expandIn = keyframes`
  from {
    opacity: 0.94;
    transform: scale(0.985);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const shrinkIn = keyframes`
  from {
    opacity: 0.94;
    transform: scale(1.02);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const slideIn = keyframes`
  from {
    opacity: 0.94;
    transform: translateX(-6px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

/* Opacity-only on page shell — transforms here bounce side panels (e.g. /metrics). */
const softFade = keyframes`
  from { opacity: 0.95; }
  to { opacity: 1; }
`;

const enterAnimations = css`
  &.is-entering > * {
    animation: ${softFade} 280ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
  }

  &.is-entering > * > *:nth-child(1) {
    animation: ${riseIn} 320ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
  }

  &.is-entering > * > *:nth-child(2) {
    animation: ${expandIn} 320ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
    animation-delay: 30ms;
  }

  &.is-entering > * > *:nth-child(3) {
    animation: ${slideIn} 320ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
    animation-delay: 50ms;
  }

  &.is-entering > * > *:nth-child(4) {
    animation: ${shrinkIn} 340ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
    animation-delay: 70ms;
  }

  &.is-entering > * > *:nth-child(5) {
    animation: ${riseIn} 340ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
    animation-delay: 90ms;
  }

  &.is-entering > * > *:nth-child(n + 6) {
    animation: ${softFade} 320ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
    animation-delay: 100ms;
  }

  /* Side rails / fixed chrome — no transform enter (prevents bounce). */
  &.is-entering > * > *[data-page-enter-static] {
    animation: none !important;
    opacity: 1 !important;
    transform: none !important;
  }

  @media (prefers-reduced-motion: reduce) {
    &.is-entering > *,
    &.is-entering > * > * {
      animation: none !important;
    }
  }
`;

export const Root = styled.div`
  /* Mirror BottomRightPanel flex item layout so page align-self rules still apply */
  width: 100%;
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  ${enterAnimations}
`;

/** Same enter motion without claiming the main page flex slot (for in-page subviews). */
export const InlineRoot = styled.div`
  width: 100%;
  ${enterAnimations}
`;
